<div
  class="c-casino__milestone"
  theming
  themingGroup="progressline"
  [themingAsset]="milestone()?.redeemed ? 'box-off' : 'box-on'">
  <div class="c-casino__milestone__content">
    <div
      [ngClass]="milestone()?.redeemed ? 'status check' : 'status'"
      theming
      themingGroup="none"
      [themingAsset]="milestone()?.redeemed ? 'check' : 'lock'"></div>
    @if (!milestone().redeemed) {
      <div
        class="shine"
        theming
        themingGroup="progressline"
        themingAsset="box-shine"></div>
    }
    @if (prizeUI()?.type === 'currency' || prizeUI()?.type === 'recurring') {
      <div
        class="prize"
        theming
        themingGroup="progressline"
        [themingAsset]="milestone()?.featured ? prizeUI()?.icon + '-featured' : prizeUI()?.icon"></div>

      <slotcom-display
        class="display-prize"
        [classes]="['c-display--milestone']">
        <div
          displayIcon
          displayIconPos="left"
          [ngClass]="prizeUI()?.icon === 'hard' ? 'c-display--gem' : 'c-display--coin'"></div>

        <span [ngStyle]="{ 'font-size': fontSize() }">
          {{
            prizeUI()?.type === 'recurring'
              ? '+' + (prizeUI()?.text | number: '1.0-0' : ('common.culture' | translate))
              : (prizeUI()?.text | notRoundingBeautifyNumber: ('common.culture' | translate))
          }}
        </span>
      </slotcom-display>
    } @else {
      <div
        class="prize"
        theming
        themingGroup="progressline"
        [themingAsset]="prizeUI()?.icon"></div>
      <slotcom-display [classes]="['c-display--milestone']">
        {{
          prizeUI()?.product === 'recurring' ? ('home.progress-line.milestone.recurring' | translate) : prizeUI()?.text
        }}
      </slotcom-display>
    }
  </div>
</div>
